import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { MAKE_SUBSCRIPTION_API } from '../../../constants/central-api';
import { getSubscriptionErrorMessage } from './subscription-error-message';

export type PackageSubscriptionResult =
  | { ok: true; data: any }
  | { ok: false; message?: string };

export type PackageSubscriptionOptions = {
  /**
   * Suppress the generic toast the request handler shows for a failed
   * response, for callers that show the reason themselves.
   */
  hideServerToast?: boolean;
};

/**
 * Starts a package subscription and reports failure explicitly, with the
 * server's message when the response carried one, so a checkout button can
 * tell the user why nothing happened. Pass `hideServerToast` when the caller
 * shows that message itself, so the user doesn't see it twice.
 */
export async function request_package_subscription(
  packageName: string,
  numberOfShops?: number | string,
  options: PackageSubscriptionOptions = {}
): Promise<PackageSubscriptionResult> {
  // const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const formData: any = new FormData();
  formData.append(`subscription_type`, 'tara-ai-services');
  formData.append('package', packageName);
  formData.append('payment_method', 'creditcard');
  formData.append('trial_active', 'false');

  if (numberOfShops) {
    formData.append('seat_count', numberOfShops.toString());
  }

  const requestInfo: RequestInfo = {
    // url: `${MAKE_SUBSCRIPTION_API}/${shopSlug}`,
    url: MAKE_SUBSCRIPTION_API,
    method: 'POST',
    body: formData,
    headers: {
      Accept: 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'MAKE_SUBSCRIPTIONS';
  const customMsg = 'Subscription activated successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    false,
    false,
    false,
    [],
    options.hideServerToast === true
  );

  const response = res?.data;
  if (res?.actionType !== actionType || response?.success !== true) {
    return { ok: false, message: getSubscriptionErrorMessage(response) };
  }

  return { ok: true, data: response?.data ?? null };
}

export default async function make_package_subscriptions_api_call(
  packageName: string,
  numberOfShops?: number | string
) {
  const result = await request_package_subscription(packageName, numberOfShops);
  return result.ok ? result.data : false;
}
